import React from "react";
import "chart.js/auto";
import { Bar } from "react-chartjs-2";
import PropTypes from "prop-types";

const VerticalBarChart = ({
  width,
  height,
  barName,
  yAxisData,
  barColor,
  showLegend,
  xAxisData,
  borderColor,
  borderWidth,
  maintainAspectRatio,
}) => {
  const options = {
    maintainAspectRatio,
    plugins: {
      legend: {
        display: showLegend,
      },
    },
  };
  const data = {
    labels: xAxisData,
    datasets: [
      {
        label: barName,
        backgroundColor: barColor,
        borderColor,
        borderWidth,
        data: yAxisData,
      },
    ],
  };

  return <Bar height={height} width={width} data={data} options={options} />;
};
VerticalBarChart.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  showLegend: PropTypes,
  xAxisData: PropTypes.shape([]),
  yAxisData: PropTypes.shape([]),
  barColor: PropTypes.shape([]),
  barName: PropTypes.string.isRequired,
  borderColor: PropTypes.string.isRequired,
  borderWidth: PropTypes.number.isRequired,
  maintainAspectRatio: PropTypes.bool,
};
VerticalBarChart.defaultProps = {
  width: 300,
  height: 100,
  xAxisData: ["january", "February", "March", "April"],
  yAxisData: ["15", "5", "10", "9"],
  barColor: ["#50CD89", "#DF2D2D"],
  maintainAspectRatio: true,
  showLegend: false,
};

export default VerticalBarChart;
